import React, { useState } from 'react';
function BirthPlanPage(){
    return(
    <div className="container mt-4">
      <h2><i className="bi bi-file-text me-2"></i>Birth Plan Template</h2>
      <div className="card mt-3">
        <div className="card-body">
          <div className="alert alert-info">
            <h5>Your Birth Preferences</h5>
            <textarea className="form-control" rows="8" placeholder="Enter your birth plan..."></textarea>
            <button className="btn btn-primary mt-3">Save Plan</button>
          </div>
        </div>
      </div>
    </div>
  );

}

export default BirthPlanPage;